import {NoWrap} from '@travel-frontend/ui-components';
import {truncate} from 'lodash';

type Props = {
  text: string;
  length?: number;
  appendix: React.ReactNode;
};

export const Truncate: React.FunctionComponent<Props> = ({
  text,
  length,
  appendix,
}) => {
  const truncatedText = length ? truncate(text, {length}) : text;
  const lastWhiteSpaceIndex = truncatedText.lastIndexOf(' ');

  if (!appendix) {
    return <>{truncatedText}</>;
  }

  if (lastWhiteSpaceIndex !== -1) {
    const firstPart = truncatedText.slice(0, lastWhiteSpaceIndex);
    const secondPart = truncatedText.slice(lastWhiteSpaceIndex + 1);

    return (
      <>
        {`${firstPart} `}
        <NoWrap as="span">
          {secondPart} {appendix}
        </NoWrap>
      </>
    );
  }

  return (
    <NoWrap as="span">
      {truncatedText} {appendix}
    </NoWrap>
  );
};
